module.exports = __webpack_public_path__ + "assets/img/ffj.472600d1.png";